/**
 * SetupFinishCard (BLU-1376, D7): shown once every visible setup step is
 * complete, and kept after the finish latch (setup never reopens; every step
 * stays reachable from the rail below it).
 *
 * Calm, not celebratory (DESIGN 13.6): the success tint, one tick, two short
 * lines, no confetti. A 3PL client and an org that prints for itself read
 * different copy; both say where the full menu now lives.
 */
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';

interface SetupFinishCardProps {
  flow: 'client' | 'owner';
}

export function SetupFinishCard({ flow }: SetupFinishCardProps) {
  const { t } = useTranslation('onboarding');
  const client = flow === 'client';
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-5 py-4 motion-safe:animate-fade-in"
    >
      <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" />
      <div className="min-w-0">
        <p className="text-sm font-semibold text-emerald-900">
          {client ? t('finish.clientTitle') : t('completion.title')}
        </p>
        <p className="mt-0.5 max-w-prose text-sm text-emerald-800">
          {client ? t('finish.clientBody') : t('completion.body')}
        </p>
        <p className="mt-1 text-sm text-emerald-800">{t('finish.menuNote')}</p>
      </div>
    </div>
  );
}
